var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AsyncIterator = require('asynciterator'); // https://en.wikipedia.org/wiki/Hash_join


var HashJoin =
/*#__PURE__*/
function (_AsyncIterator) {
  "use strict";

  _inherits(HashJoin, _AsyncIterator);

  function HashJoin(left, right, funHash, funJoin) {
    var _this;

    _classCallCheck(this, HashJoin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HashJoin).call(this, right));
    _this.left = left;
    _this.right = right;
    _this.funHash = funHash;
    _this.funJoin = funJoin;
    _this.leftMap = new Map();
    _this.match = null;
    _this.matches = [];
    _this.matchIdx = 0;
    _this.readable = false;

    _this.left.on('end', allowJoining.bind(_assertThisInitialized(_this)));

    _this.left.on('data', addItem.bind(_assertThisInitialized(_this)));

    function addItem(item) {
      var hash = this.funHash(item);
      if (!this.leftMap.has(hash)) this.leftMap.set(hash, []);
      var arr = this.leftMap.get(hash);
      arr.push(item);
    }

    function allowJoining() {
      var _this2 = this;

      if (this.leftMap.size <= 0) return this.close();
      this.readable = true;
      this.right.on('readable', function () {
        return _this2.readable = true;
      });
      this.right.on('end', function () {
        if (!_this2.hasResults()) _this2._end();
      });
    }

    return _this;
  }

  _createClass(HashJoin, [{
    key: "hasResults",
    value: function hasResults() {
      return !this.right.ended || this.matchIdx < this.matches.length;
    }
  }, {
    key: "close",
    value: function close() {
      _get(_getPrototypeOf(HashJoin.prototype), "close", this).call(this);

      this.left.close();
      this.right.close();
    }
  }, {
    key: "read",
    value: function read() {
      if (this.ended || !this.readable) return null;

      while (this.matchIdx < this.matches.length) {
        var item = this.matches[this.matchIdx++];
        var result = this.funJoin(item, this.match);
        if (result !== null) return result;
      }

      if (!this.hasResults()) this._end();
      this.match = this.right.read();

      if (this.match === null) {
        this.readable = false;
        return null;
      }

      var hash = this.funHash(this.match);
      this.matches = this.leftMap.get(hash) || [];
      this.matchIdx = 0; // array is filled again so recursive call can have results

      return this.read();
    }
  }]);

  return HashJoin;
}(AsyncIterator);

module.exports = HashJoin;